import classNames from "classnames";
import styles from "./LinkGridItem.module.scss";
import { ImageProps } from "components/base/Image/Image";
import Media from "components/utils/Media/Media";
import IconMS from "../../../utils/IconMS/IconMS";
import Tag, { TagProps } from "components/base/Tag/Tag";

export interface LinkGridItemProps {
  categoryList?: string[];
  description?: string;
  eventType?: "digital" | "physical";
  image?: ImageProps;
  pageType: string;
  date?: string;
  tags?: TagProps[];
  title: string;
  type: "medium" | "small";
  url: string;
}

const PlaceholderSVG: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 75"
    preserveAspectRatio="xMidYMid meet"
    className={styles.placeholder}
  >
    <rect width="100%" height="100%" fill="#f0f0f0" />
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      fill="#a0a0a0"
      fontSize="12px"
      dy=".3em"
    >
      No Image
    </text>
  </svg>
);

const LinkGridItem: React.FC<LinkGridItemProps> = ({
  categoryList,
  description,
  eventType,
  image,
  pageType,
  tags,
  title,
  type = "small",
  url,
  date,
}) => {
  const isMedium = type === "medium";
  const showImage =
    pageType === "infopage" ||
    pageType === "publicationpage" ||
    pageType === "examplepage"
      ? true
      : false;

  const noBackgroundColor =
    pageType === "examplepage"
      ? true
      : false || pageType === "tilskuddpage"
        ? true
        : false;

  const noDescription = pageType === "sectionpage" || pageType === "eventpage";

  const firstCategory =
    categoryList && categoryList.length ? categoryList[0] : undefined;

  return (
    <a
      href={url}
      className={classNames(styles.linkGridItem, {
        [styles.isMedium]: isMedium,
        [styles.noBackgroundColor]: noBackgroundColor,
        [styles.withBorder]: pageType === "tilskuddpage",
        [styles.outLineCard]:
          pageType === "tilskuddpage" || pageType === "examplepage",
        [styles.examplePagePadding]: pageType === "examplepage",
      })}
    >
      {showImage && (
        <div
          className={classNames(styles.imageContainer, {
            [styles.fullBorder]: pageType === "examplepage",
          })}
        >
          {image ? (
            <Media image={{ ...image, ratio: "medium" }} />
          ) : (
            <PlaceholderSVG />
          )}
        </div>
      )}
      <div
        className={classNames(styles.textContainer, {
          [styles.withIcon]:
            pageType === "sectionpage" || pageType === "eventpage",
          [styles.fullText]: pageType === "examplepage",
        })}
      >
        <div className={styles.titleContainer}>
          {(pageType === "sectionpage" || eventType) && (
            <IconMS
              className={styles.icon}
              name={
                pageType === "sectionpage"
                  ? "arrow_forward"
                  : eventType === "digital"
                    ? "mimo"
                    : "distance"
              }
              size="48px"
            />
          )}
          <div>
            {date && <p className={styles.subtext}>{date}</p>}
            {firstCategory && <p className={styles.subtext}>{firstCategory}</p>}
            <h3>{title}</h3>
          </div>
        </div>

        {!noDescription && description && (
          <p className={styles.description}>{description}</p>
        )}

        {tags && tags.length > 0 && (
          <ul
            className={classNames(styles.tagList, {
              [styles.eventPage]: pageType === "eventpage",
            })}
          >
            {tags
              .map((tag, index) => (
                <li key={index}>
                  {index < 2 ? (
                    <Tag {...tag} className={styles.tag} />
                  ) : (
                    <Tag text={`+${index - 1}`} className={styles.numberTag} />
                  )}
                </li>
              ))
              .slice(0, 3)}
          </ul>
        )}
      </div>
    </a>
  );
};

export default LinkGridItem;
